// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"181171b4","182":"f8704d93","313":"a970f504","350":"6ea797ba","736":"e65ff223","796":"1ee7b716","979":"6f89f95f"}[chunkId] + ".chunk.css";
};